// extracted by mini-css-extract-plugin
export var closed = "_gr-1";
export var resizer = "_gr-0";